import { render, staticRenderFns } from "./ProtocoloComparativo.vue?vue&type=template&id=fa65e2d8&scoped=true"
import script from "./ProtocoloComparativo.vue?vue&type=script&lang=ts"
export * from "./ProtocoloComparativo.vue?vue&type=script&lang=ts"
import style0 from "./ProtocoloComparativo.vue?vue&type=style&index=0&id=fa65e2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa65e2d8",
  null
  
)

export default component.exports